import React from 'react';
import { useSettings } from '../context/SettingsContext';
import { homeBlockCatalog, visibleHomeBlocks } from '../lib/homeLayout';

/** Ana sayfanın tek bölümü. DOM'a hiçbir şey eklemez.
 *
 * Sarmalayıcı bilinçli olarak bir kap (div) çizmez: şemaların CSS'i
 * bölümlerin doğrudan kardeş olmasına dayanır (boşluklar, `+` seçicileri) ve
 * araya giren bir kap görünümü sessizce değiştirirdi. Bölümün kendi koşulu
 * (`{items.length > 0 && …}`) içeride kalır; `HomeBlocks` yalnızca sırayı ve
 * panelden gizlenenleri belirler.
 */
export const HomeBlock = ({ children }) => <>{children}</>;

/** Panelden seçilen düzene göre bölümleri sıralar ve gizlenenleri düşürür.
 *
 * Düzen `/settings` yanıtındaki `home_layout` listesidir (yalnızca yayındaki
 * şemanınki). Kataloğu `lib/homeLayout.js` taşır. Katalogda bulunmayan bir
 * `HomeBlock` kaybolmaz, sona eklenir: bölümü kataloğa yazmayı unutan bir
 * değişiklik onu sitede görünmez yapmamalıdır.
 *
 * React kimliği `Children.toArray`'in konum anahtarıdır; JSX'teki yer
 * değişmediği için sıra değişse de bölüm yeniden kurulmaz, yalnızca taşınır.
 */
const HomeBlocks = ({ theme, children }) => {
  const settings = useSettings();
  const byId = new Map();
  const extras = [];
  React.Children.toArray(children).forEach((child) => {
    if (React.isValidElement(child) && child.type === HomeBlock && child.props.id) {
      byId.set(child.props.id, child);
    } else {
      extras.push(child);
    }
  });
  const order = visibleHomeBlocks(theme, settings.home_layout);
  // Gizlenen bölüm katalogdadır ve düşer; katalogda hiç olmayan sona eklenir.
  const catalog = new Set(homeBlockCatalog(theme));
  const unlisted = [...byId.keys()].filter((id) => !catalog.has(id));
  return (
    <>
      {order.map((id) => byId.get(id)).filter(Boolean)}
      {unlisted.map((id) => byId.get(id))}
      {extras}
    </>
  );
};

export default HomeBlocks;
